import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { generateValidUrl, isValidUrl } from "utils/helpers";
import CustomizedTooltip from "components/common/customized-tooltip";
import { Box, Icon } from "@mui/material";
import { Link } from "@mui/icons-material";

const socialInputWrapperSx = {
  display: "flex",
  "& > .icon": {
    height: "calc(1rem + 2px)",
    py: 1.5,
    px: 0,
    mt: 0.25,
    mr: 1.5,
    boxSizing: "content-box",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }
};

const FieldUrl = ({ name, label, icon, FormField, watch, ...props }) => {
  const value = watch(name);

  const isValid = useMemo(() => isValidUrl(value), [value]);

  const generate = useMemo(() => generateValidUrl(value), [value]);

  return (
    <Box sx={socialInputWrapperSx}>
      <CustomizedTooltip title="Open in new tab" placement="top" arrow hidden={!isValid}>
        <Icon
          className="icon"
          component="a"
          target="_blank"
          rel="noopener noreferrer"
          color={isValid ? "primary" : "disabled"}
          {...(isValid && { href: generate })}
        >
          {icon || <Link />}
        </Icon>
      </CustomizedTooltip>
      {FormField({
        name,
        ...(label && { label }),
        ...props
      })}
    </Box>
  );
};

export default FieldUrl;

FieldUrl.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  icon: PropTypes.element,
  FormField: PropTypes.func.isRequired,
  watch: PropTypes.func.isRequired
};

FieldUrl.defaultProps = {
  icon: undefined
};
